import styled from "@emotion/styled";
import { colors } from "@ui/style/colors";
import { splitTextWithQueryString } from "@utils/string-utils";
import React, { Fragment, useMemo } from "react";

interface HighlightedStringProps {
	text: string;
	queryString: string;
}

export const HighlightedString = ({ text, queryString }: HighlightedStringProps): JSX.Element => {
	const stringParts = useMemo(() => splitTextWithQueryString(text, queryString), [queryString, text]);
	return (
		<>
			{stringParts.map((substring, index) => (
				<Fragment key={`${substring.text}-${index}` }>
					{substring.isQueryString ? (
						<HighlightedSpan>{substring.text}</HighlightedSpan>
					) : (
						<span>{substring.text}</span>
					)}
				</Fragment>
			))}
		</>
	);
};

const HighlightedSpan = styled.span`
	font-weight: bold;
	background-color: ${colors.primary10};
	border-radius: 0.1em;
`;
